// src/api/Timesheetform-api.js
import axios from "axios";

const API_URL = "https://ims.holdthechild.net";

/**
 * FETCH MY TIMESHEETS
 */
export const fetchMyTimesheets = async (token) => {
  try {
    const response = await axios.get(`${API_URL}/api/timesheets/my-timesheets`, {
      headers: { Authorization: `Bearer ${token}` },
    });
    return response.data.data || response.data || [];
  } catch (error) {
    console.error("API: Error fetching personal timesheets:", error);
    throw error;
  }
};

/**
 * SUBMIT NEW TIMESHEET
 */
export const submitTimesheet = async (timesheetData, token) => {
  try {
    const response = await axios.post(`${API_URL}/api/timesheets`, timesheetData, {
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    });
    return response.data;
  } catch (error) {
    console.error("API: Error submitting timesheet:", error);
    throw error;
  }
};

/**
 * FETCH ALL PENDING (Approver Only)
 */
export const fetchAllPendingTimesheets = async (token) => {
  try {
    const response = await axios.get(`${API_URL}/api/timesheets/all-pending`, {
      headers: { Authorization: `Bearer ${token}` },
    });
    return response.data.data || response.data || [];
  } catch (error) {
    console.error("API: Error fetching global pending list:", error);
    throw error;
  }
};

/**
 * FETCH ALL TIMESHEETS — all statuses (Approver full history view)
 */
export const fetchAllTimesheets = async (token) => {
  try {
    const response = await axios.get(`${API_URL}/api/timesheets/all-timesheets`, {
      headers: { Authorization: `Bearer ${token}` },
    });
    return response.data.data || response.data || [];
  } catch (error) {
    console.error("API: Error fetching all timesheets:", error);
    throw error;
  }
};

/**
 * APPROVE/REJECT ACTIONS
 */
export const verifyTimesheetAction = async (id, status, reason = "", token) => {
  try {
    const normalizedStatus = status.toLowerCase();
    const isApprove = normalizedStatus === "approved" || normalizedStatus === "approve";
    const endpoint = isApprove ? "approve" : "reject";

    console.log(`Attempting to ${endpoint} timesheet: ${id}`);

    const response = await axios.patch(
      `${API_URL}/api/timesheets/${id}/${endpoint}`,
      {
        rejectionReason: reason,
        status: isApprove ? "approved" : "rejected",
      },
      {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      }
    );
    return response.data;
  } catch (error) {
    console.error(`API Error details:`, error.response?.data || error.message);
    throw error;
  }
};

// Alias for convenience
export const updateTimesheetStatus = (id, data, token) => {
  return verifyTimesheetAction(id, data.status, data.rejectionReason, token);
};